import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'workers_are_not_using_fall_protection_when_needed'

export const dataPointDefinition = {
  retracedId: 'workers_are_not_using_fall_protection_when_needed',
  name: 'Workers are not using fall protection when needed',
  description:
    'Common fall protection equipment includes harnesses, lanyards, lifelines, anchor points, and self-retracting lifelines. These are designed to prevent or arrest falls and protect workers at heights.',
  meta: {
    slcpMeta: {
      key: 'hs-bui-30x',
      number: 'HS-BUI-7-1',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'hs-bui-29',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2]',
      machineShowHide: '[2]',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-bui-30x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 29590,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
